module.exports = __webpack_public_path__ + "static/img/c5.ca52a89.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/c5.png
// module id = 280
// module chunks = 0 1 2 3 4 5 6 7 8 9